//@ts-nocheck
import { memo, useEffect, useState } from 'react'
import { Dimensions } from 'react-native'
import { DataProvider, LayoutProvider, RecyclerListView } from 'recyclerlistview'
interface CustomSectionListProps {
  renderItem: any
  data: []
  renderHeader?: any
  selected?: any
  renderEmpty?: any
  extraData?: Array<any>
}

const CustomSectionList = memo(
  ({ renderItem, data, renderHeader, selected, renderEmpty, extraData }: CustomSectionListProps) => {
    const [_dataProvider, setDataProvider] = useState(
      new DataProvider((r1, r2) => {
        return r1 !== r2
      }).cloneWithRows(data),
    )

    useEffect(() => {
      setDataProvider((dataProvider) => dataProvider.cloneWithRows(data))
    }, [data])

    const _renderRecycleView = (_type: any, item: any, index: any) => {
      if (_type === 'HEADER') {
        return renderHeader({ item, index })
      } else {
        return renderItem({ item, index })
      }
    }

    const [_layoutProvider, setLayoutProvider] = useState(null)

    useEffect(() => {
      setLayoutProvider(
        new LayoutProvider(
          (index) => {
            const item: any = data[index]
            if (item?.type === 'HEADER') {
              return 'HEADER'
            }
            return 'ITEM'
          },
          (type, dim) => {
            switch (type) {
              case 'HEADER':
                dim.width = Math.round(Dimensions.get('window').width)
                dim.height = 40
                break
              default:
                dim.width = Math.round(Dimensions.get('window').width)
                dim.height = 70
                break
            }
          },
        ),
      )
    }, [data, selected])

    return (
      <>
        {data && data.length > 0 && (
          <RecyclerListView
            style={{ minHeight: 100 }}
            removeClippedSubviews
            dataProvider={_dataProvider}
            rowRenderer={_renderRecycleView}
            layoutProvider={_layoutProvider}
            extendedState={extraData}
          />
        )}
        {(!data || data.length === 0) && renderEmpty && renderEmpty()}
      </>
    )
  },
)

export { CustomSectionList }
